import CompanyList from './CompaniesList';

export default CompanyList;

